export default "__VITE_ASSET__YeGDbYpy__"